'use strict';

var Consts = require('consts');
var BaseDeviceSettingsView = require('components/devices/views/common/base_device_settings_view');
var Device = require('models/devices');

var SettingsView = BaseDeviceSettingsView.extend({
    template: require('components/devices/templates/controller/settings'),

    getFormDefaults: function () {
        return {
            key_number: 1732,
        };
    },

    getInputFields: function () {
        return {
            name: {},
            station: {},
            key_number: {},
        };
    },

    getUpdatedModel: function (form) {
        return {
            name: form.name,
            station: parseInt(form.station),
            key_number: parseInt(form.key_number),
        };
    },

    getNewModel: function (form, parent_id) {
        return new Device.Model({
            parent: parseInt(parent_id) || 0,
            name: form.name,
            station: parseInt(form.station) || 0,
            key_number: parseInt(form.key_number) || 0,
            category: Consts.Category.Controller,
        });
    },
});

module.exports = SettingsView;
